import pgsDashboard from "./pgs/dashboard"
import pgsDataManage from "./pgs/dataManage"
import pgsReport from "./pgs/report"

import azfReport from "./pgs/report"

import pgdDashboard from "./pgd/dashboard"
import pgdDataManage from "./pgd/dataManage"
import pgdReport from "./pgd/report"

import entrance from "./entrance"
import auth from "./auth"

function getStores (preStores) {
  const keys = Object.keys(preStores)
  const stores = {}
  keys.forEach(key => {
    if (typeof preStores[key] === "function") {
      stores[key] = new preStores[key]()
    } else {
      stores[key] = preStores[key]
    }
  })
  return stores
}

export default getStores({
  pgsDashboard,
  pgsDataManage,
  pgsReport,

  pgdDashboard,
  pgdDataManage,
  pgdReport,

  azfReport,

  entrance,
  auth,
})



// WEBPACK FOOTER //
// ./src/app/stores/index.js